import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Corruption extends Bloc {

	constructor (src, ctx) {

		super("corruption", src, ctx);
		this.f = (src, ins) => [src.master.run.champion.corruption];
		this.types = [];
	}
}